import { useState, useEffect } from "react";
import { GetMocktestQuestion } from "../../../Client/request";
import { useContext } from "react";
import PteAttemptContext from "../PteAttemptContext";

export const useListeningQuestion = (quest, startStopwatch, cachedQuestionData = null) => {
  const attemptId = useContext(PteAttemptContext);
  const [questData, setQuestData] = useState(cachedQuestionData || null);
  const [loading, setLoading] = useState(!cachedQuestionData);
  const [error, setError] = useState(false);
  const [retryCount, setRetryCount] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    if (quest) {
      setError(false);
      setLoading(true);
      setQuestData(null);
      if (cachedQuestionData) {
        setQuestData(cachedQuestionData);
        setLoading(false);
        startStopwatch();
        return;
      }

      GetMocktestQuestion(quest.QuestionId, attemptId, {
        signal: controller.signal, timeout: 30000,
      }).then((res) => {
        if (controller.signal.aborted) return;
        if (res?.data) {
          setQuestData(res.data);
          startStopwatch();
        } else {
          setError(true);
        }
      }).catch(() => {
        if (!controller.signal.aborted) setError(true);
      }).finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });
    }
    return () => controller.abort();
    // eslint-disable-next-line
  }, [quest, cachedQuestionData, attemptId, retryCount]); // startStopwatch intentionally omitted to prevent re-renders

  return {
    questData,
    loading,
    setQuestData,
    error,
    retry: () => setRetryCount(count => count + 1),
  };
};
